import firebase from 'firebase'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/messaging'
import 'firebase/storage'

const config = {
  apiKey: 'AIzaSyAfTj0LTDb-sk7YaFSLLAtJP0P-eWbHKts',
  authDomain: 'student-tracker-43fc4.firebaseapp.com',
  databaseURL: 'https://student-tracker-43fc4.firebaseio.com',
  projectId: 'student-tracker-43fc4',
  storageBucket: 'student-tracker-43fc4.appspot.com',
  messagingSenderId: '397510232608'
}

firebase.initializeApp(config)

if (process.env.NODE_ENV === 'development') {
  window.auth = firebase.auth()
  window.database = firebase.database()
  window.storage = firebase.storage()
}

export const provider = new firebase.auth.EmailAuthProvider()
export const auth = firebase.auth()
export const database = firebase.database()
export const messaging = firebase.messaging()
export const storage = firebase.storage()
export default firebase


// WEBPACK FOOTER //
// ./src/helpers/firebase.js